import router from '@/router'

const state = {
    from: {},
    to: {},
}

const mutations = {
    SET_FROM: (state, from) => {
        state.from = from
    },
    SET_TO: (state, to) => {
        state.to = to
    },
}

const actions = {
    goBack({ state }, pageKey) {
        return new Promise(resolve => {
            const path = state.from.path
            const currentPath = state.to.path
            if(path) {
                const isInclude = currentPath.endsWith('/add') || currentPath.endsWith('/edit') ? true : false
                if(isInclude && path.startsWith('/' + pageKey) || ('/' + pageKey) === path) {
                    router.back()
                    resolve(true)
                }else {
                    router.push('/' + pageKey)
                    resolve(false)
                }
            }else {
                router.push('/' + pageKey)
                resolve(false)
            }
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}